import vToggle from "./v-toggle.vue";

export default Vue => {
  Vue.component("v-toggle", vToggle);
};
